import styled from 'styled-components/macro'

export const ToggleInput = styled.input`
  position: relative;
  width: 3.5rem;
  height: 2rem;
  display: block;
  background-color: ${(props) => props.theme.color.elementBg};
  border-radius: 10rem;
  cursor: pointer;
  transition: background-color 0.2s, box-shadow 0.2s;
  outline: none;
  &:disabled {
    opacity: ${({ theme }) => theme.opacity.opacity05};
    cursor: no-drop;
  }
  &:focus {
    box-shadow: 0 0 0.1rem 0.1rem ${(props) => props.theme.color.elementBgSecond};
  }
  &:checked {
    background-color: ${(props) => props.theme.color.buttonBgThird};
  }
  &::after {
    content: '';
    position: absolute;
    top: 0.2rem;
    left: 0.2rem;
    width: 1.6rem;
    height: 1.6rem;
    background-color: ${(props) => props.theme.color.elementBgSecond};
    border-radius: 50%;
    transition: all 0.2s;
  }
  &:active {
    &::after {
      width: 1.8rem;
    }
  }
  &:checked {
    &::after {
      left: calc(100% - 0.2rem);
      background-color: ${(props) => props.theme.color.elementBg};
      transform: translateX(-100%);
    }
  }
`
